module.exports = [{"name":"Facebook","url":"https://facebook.com/quickepay","icon":"facebook"}]


//////////////////
// WEBPACK FOOTER
// ./src/database/social.json
// module id = GfIz
// module chunks = 0